var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',{staticClass:"paginate",attrs:{"layout":"prev, pager, next","current-page":_vm.currentPage,"page-size":_vm.LIMIT,"total":_vm.totalPage,"background":""},on:{"current-change":_vm.handleCurrentChange}})}
var staticRenderFns = []

export { render, staticRenderFns }